<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="para1"><a id="page_iv"></a><span class="smallcaps">NOTE:</span> If you purchased this book without a cover, you should be aware that this book is stolen property. It was reported as “unsold and destroyed” to the publisher, and neither the author nor the publisher has received any payment for this “stripped book.”</p>
<p class="para1">This is a work of fiction. All of the characters, organizations, and events portrayed in this novel are either products of the author’s imagination or are used fictitiously.</p>
<p class="para1">THE PIRATE HUNTERS</p>
<p class="para1">Copyright © 2010 by Mack Maloney</p>
<p class="para1">All rights reserved.</p>
<p class="para1">Edited by James Frenkel</p>
<p class="para1">A Forge Book<br/>Published by Tom Doherty Associates, LLC<br/>175 Fifth Avenue<br/>New York, NY 10010</p>
<p class="para1"><a href="http://www.tor-forge.com" target="_blank">www.tor-forge.com</a></p>
<p class="para1">Forge<sup>®</sup> is a registered trademark of Tom Doherty Associates, LLC.</p>
<p class="para1">ISBN 978-0-7653-6521-7</p>
<p class="para1">First Edition: May 2010</p>
<p class="para1">Printed in the United States of America</p>
<p class="para1">0   9   8   7   6   5   4   3   2   1</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?3dc73689